module.exports = __webpack_public_path__ + "static/media/FattyPay_DuitNow_Mobile.59bc16c4.svg";